module.exports = __webpack_public_path__ + "img/4cast-logo-white.7ccc4b08.svg";